// The restored / checked strip (2026-10-27, docs/contact-view.md "Parking"):
// "Restored your work from …" and "Checked for changes: nothing new since you
// parked this." together, at the top of the suggestion, in one small info
// strip that stands out (a light info background, the info icon, bold text in
// the body color). The panel hides it once the CSR edits something, ticks a
// step's checkbox, clicks Process or sends (2026-10-28);
// the x closes it. When unpark found something, the "Since you parked this"
// panel (ParkComparePanel.jsx) takes its place. When only order facts or a
// new customer message changed, nothing asks: the strip lists them under the
// check line (changes, 2026-10-28), and then only its x closes it.

import { Alert, Box, Button, Typography } from '@mui/material'

// startFromDraftLabel / onStartFromDraft (2026-10-30): when the restored work
// was someone else's ("Restored Bo's work from …"), one click drops it and
// loads the AI draft instead.
export default function ParkInfoStrip({ restoredLine = null, checkLine = null, changes = [], onClose, startFromDraftLabel = null, onStartFromDraft = null }) {
  if (!restoredLine && !checkLine) return null
  const text = { fontWeight: 600, color: 'text.primary', lineHeight: 1.4 }
  return (
    <Alert severity="info" onClose={onClose} data-testid="park-info-strip"
      slotProps={{ closeButton: { 'aria-label': 'Close', title: 'Close', size: 'small' } }}
      sx={{ mb: 1, py: 0.25, alignItems: 'center', '& .MuiAlert-message': { py: 0.5 } }}>
      {restoredLine && <Typography variant="body2" component="div" sx={text} data-testid="restored-work-line">{restoredLine}</Typography>}
      {restoredLine && startFromDraftLabel && onStartFromDraft && (
        <Button size="small" variant="outlined" color="inherit" onClick={onStartFromDraft} sx={{ mt: 0.5, textTransform: 'none' }} data-testid="start-from-ai-draft">
          {startFromDraftLabel}
        </Button>
      )}
      {checkLine && <Typography variant="body2" component="div" sx={text} data-testid="park-nothing-new">{checkLine}</Typography>}
      {changes?.length > 0 && (
        <Box component="ul" sx={{ m: 0, pl: 2.5 }} data-testid="park-strip-changes">
          {changes.map((line, i) => <li key={i}><Typography variant="body2" sx={{ color: 'text.primary' }}>{line}</Typography></li>)}
        </Box>
      )}
    </Alert>
  )
}
